import React, { createContext } from "react";
import { CompetitorFamily, CompetitorMember, CompetitorOriginationLink, CompetitorAgentLink, CompetitorCommodityLink } from "./external";

export const ExternalContext = createContext({
    families: [] as CompetitorFamily[],
    familyById: {} as Record<number, CompetitorFamily>,
    familyByReference: {} as Record<string, CompetitorFamily>,
    postFamily: (family: CompetitorFamily) => Promise.resolve(family),
    deleteFamily: (family: CompetitorFamily) => Promise.resolve({}),

    members: [] as CompetitorMember[],
    memberById: {} as Record<number, CompetitorMember>,
    memberByReference: {} as Record<string, CompetitorMember>,
    membersByFamilyId: {} as Record<number, CompetitorMember[]>,
    postMember: (member: CompetitorMember) => Promise.resolve(member),
    deleteMember: (member: CompetitorMember) => Promise.resolve({}),

    originationLinks: [] as CompetitorOriginationLink[],
    postOriginationLink: (arg: (CompetitorOriginationLink | CompetitorOriginationLink[])) => Promise.resolve(arg),
    deleteOriginationLink: (arg: (CompetitorOriginationLink | CompetitorOriginationLink[])) => Promise.resolve({}),

    competitorAgentLinks: [] as CompetitorAgentLink[],
    postCompetitorAgentLink: (arg: (CompetitorAgentLink | CompetitorAgentLink[])) => Promise.resolve(arg),
    deleteCompetitorAgentLink: (arg: (CompetitorAgentLink | CompetitorAgentLink[])) => Promise.resolve({}),
    // linkType -> memberId -> [agentIds]
    agentsByMemberId: {} as Record<string, Record<number, number[]>>,

    competitorCommodityLinks: [] as CompetitorCommodityLink[],
    postCompetitorCommodityLink: (arg: (CompetitorCommodityLink | CompetitorCommodityLink[])) => Promise.resolve(arg),
    deleteCompetitorCommodityLink: (arg: (CompetitorCommodityLink | CompetitorCommodityLink[])) => Promise.resolve({}),

    parents: {} as Record<number, number[]>,

    isLoading: false as boolean,
    reload: () => {},
});

export function useExternal() {
    return React.useContext(ExternalContext)
}